/// <amd-module name="DistributedTaskUI/ServiceEndpoints/Details/Components/ServiceEndpointUpgradeDetailsComponent" />
import * as React from "react";

import * as Resources from "DistributedTaskUI/ServiceEndpoints/Details/Resources";
import {
    IServiceEndpointComponentState,
    ConversionStatus,
    ServiceEndpointStore
} from "DistributedTaskUI/ServiceEndpoints/Details/Stores/ServiceEndpointStore";
import { StoreManager } from "DistributedTask/Flux/StoreManager";
import * as EndpointConstants from "ServiceEndpoints/Client/Constants/ServiceEndpoint";

import { Card } from "VSSUI/Card";
import { Button } from "VSSUI/Button";
import { TitleSize } from "VSSUI/Header";
import { copyToClipboard } from "VSSUI/Clipboard";
import * as Utils_String from "VSS/Core/Util/String";
import { Location } from "VSSUI/Utilities/Position";

import { VssComponent, IVssComponentContext } from "VSS/Platform/Layout";

enum CopiedItem {
    SUBJECT = "subject",
    ISSUER = "issuer"
}

export interface IServiceEndpointUpgradeDetailsComponentProps {}

export class ServiceEndpointUpgradeDetailsComponent extends VssComponent<
    IServiceEndpointUpgradeDetailsComponentProps,
    IServiceEndpointComponentState
> {
    constructor(props: IServiceEndpointUpgradeDetailsComponentProps, context: IVssComponentContext) {
        super(props, context);
        this._store = StoreManager.GetStore<ServiceEndpointStore>(ServiceEndpointStore, ServiceEndpointStore.getKey());
        this.state = ServiceEndpointStore.getDefaultState();
    }

    public UNSAFE_componentWillMount(): void {
        this.setState(this._store.getState());
    }

    public componentDidMount(): void {
        this._store.addChangedListener(this._onStoreChanged);
    }

    public componentWillUnmount(): void {
        this._store.removeChangedListener(this._onStoreChanged);
    }

    private _onStoreChanged = (): void => {
        this.setState(this._store.getState());
    }

    private _renderAuthorizationParamField(label: string, fieldName: string): React.ReactNode {
        return this.state.serviceEndpoint.authorization.parameters[fieldName] ?
            <React.Fragment>
                <div className="sc-data-label secondary-text">{label}:</div>
                <div className="sc-data-value selectable-text">{this.state.serviceEndpoint.authorization.parameters[fieldName]}</div>
            </React.Fragment> : null;
    }

    public render(): React.ReactNode {
        const isServicePrincipal = this._schemeEquals(EndpointConstants.EndpointAuthorizationSchemes.ServicePrincipal);
        const isConversionFailed = this.state.conversionStatus === ConversionStatus.FAILED;

        if (isServicePrincipal && isConversionFailed) {
            return (
                <Card
                    className="service-connection-details-card flex-column margin-top-16"
                    contentProps={{ contentPadding: false }}
                    titleProps={{
                        size: TitleSize.Medium,
                        text: Resources.UpgradeCardTitle
                    }}
                >
                    <div className="flex-grow service-connection-details-container">
                        <div className="details-content-header body-s secondary-text font-weight-semibold">{Resources.ServicePrincipal}</div>
                        <div className="details-content-data">
                            <div className="sc-details-table">
                                <div className="sc-data-label secondary-text">{Resources.WorkloadIdentityFederationIssuer}:</div>
                                <div className="sc-data-value">
                                    {this.state.oidcFederationIssuer}
                                    {this._renderCopyButton(CopiedItem.ISSUER, () => this._copyFederationIssuer())}
                                </div>
                                <div className="sc-data-label secondary-text">{Resources.WorkloadIdentityFederationSubject}:</div>
                                <div className="sc-data-value">
                                    {this.state.oidcFederationSubject}
                                    {this._renderCopyButton(CopiedItem.SUBJECT, () => this._copyFederationSubject())}
                                </div>
                                { this._renderAuthorizationParamField(Resources.ARMServiceConnectionUpgradeInputApplicationId, EndpointConstants.AzureEndpointConstants.SpnClientId) }
                                { this._renderAuthorizationParamField(Resources.ARMServiceConnectionUpgradeInputTenantId, EndpointConstants.AzureEndpointConstants.TenantId) }
                            </div>
                        </div>
                    </div>
                </Card>
            );
        }
        return null;
    }

    private _schemeEquals(scheme: string) {
        return Utils_String.equals(this.state.serviceEndpoint.authorization.scheme, scheme, true);
    }

    private _renderCopyButton(item: CopiedItem, onCopy: () => void): React.ReactNode {
        return (
            <Button
                subtle={true}
                ariaLabel={Resources.ClipboardCopy}
                iconProps={{ iconName: "Copy" }}
                onClick={onCopy}
                tooltipProps={{
                    anchorOffset: { horizontal: 0, vertical: 0 },
                    anchorOrigin: { horizontal: Location.center, vertical: Location.start },
                    text: this.state.itemCopiedToClipboard === item ? Resources.ClipboardCopyTooltipCopied : Resources.ClipboardCopyTooltip,
                    tooltipOrigin: { horizontal: Location.center, vertical: Location.end }
                }}
            />
        );
    }

    private _copyFederationSubject() {
        copyToClipboard(this.state.oidcFederationSubject);

        this.setState({
            itemCopiedToClipboard: CopiedItem.SUBJECT
        });
    }

    private _copyFederationIssuer() {
        copyToClipboard(this.state.oidcFederationIssuer);

        this.setState({
            itemCopiedToClipboard: CopiedItem.ISSUER
        });
    }
    private _store: ServiceEndpointStore;
}
